import { Container, Nav } from "react-bootstrap";

const Navigation = () => {
  return (
    <Nav className="ttc-secondary">
      <Container className="text-white">
        <h1 className="ttc-txt-primary">Tic Tac Toe</h1>
      </Container>
    </Nav>
  );
};

export default Navigation;
